import { createSlice } from '@reduxjs/toolkit'

const tokenSlice = createSlice({
    name: 'token',
    initialState: { loading: true, error: null },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                state.error = null
                return
            }

            state.error = payload
        },
        getToken() {
            //Runs method for getting token
        },
        deleteToken() {
            localStorage.removeItem('token')
            localStorage.removeItem('token_validity')
        },
    },
})

const { actions, reducer } = tokenSlice

export const { setLoading, setError, getToken, deleteToken } = actions

export default reducer
